import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { FormattedMessage, useIntl } from 'react-intl';
import { ProcessState } from '../../models/ProcessState';
import { EnumSelectField } from '../bootstrap/EnumSelectField';
import { NumberInputField } from '../bootstrap/NumberInputField';

export function ListFilterBar({ filters, setFilters, search, isB17 }) {
  const intl = useIntl();

  function handleFilterChange(e, name) {
    filters[name] = e.target.value;
    setFilters({ ...filters });
  }

  const versionTypes = ['first','replacement'];

  return (
    <>
      <Row className='searchFilters'>
        <Col md='3'>
          <EnumSelectField
            preffixDescriptionId={'processState'}
            handleChange={(e) => handleFilterChange(e, 'state')}
            options={ProcessState.values()}
            value={filters.state}
            nullOption={true}
            nullOptionSuffix={'state'}
          />
        </Col>
        {/*  Uncomment to add the feature of filtering by the form type (1st version or replacemente)
        { isB17 && 
        <Col md='2'>
          <EnumSelectField
            preffixDescriptionId={'versionType'}
            handleChange={(e) => handleFilterChange(e, 'replacement')}
            options={versionTypes}
            value={filters.replacement}
            nullOption={true}
            nullOptionSuffix={'versionType'}
          />
        </Col>
        }
        */}
        <Col md='2'>
          <NumberInputField
            handleChange={(e) => handleFilterChange(e, 'year')}
            value={filters.year}
            maxLength={4}
            placeholder={intl.formatMessage({id:'all.year'})}
          />
        </Col>
        <Col md='3'>
          <button className='btn btn-outline-primary' onClick={() => search(true)} type='button'>
            <FaSearch /> <FormattedMessage id='all.search' />
          </button>
        </Col>
      </Row>
    </>
  );
}
